// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Icon from '../../../../../components/icons/Icon';
import AnchorButton from '../../../../../components/buttons/AnchorButton';
import TimeInput from '../../../../../components/datetime/TimeInput';
import StyledButton from '../../../../../components/buttons/StyledButton';

// Styles
import './DueDateTimePicker.scss';

interface DueDateTimePickerProps {
    hasDueDateTime: boolean;
    setHasDueDateTime: (has: boolean) => void;
    dueDate: Date;
    setDueDate: (date: Date) => void;
    unsetTimeMessage?: string;
}

interface UnsetDueDateTimePickerProps {
    setHasDueDateTime: (has: boolean) => void;
    unsetTimeMessage?: string;
}

const UnsetDueDateTimePicker: React.FC<Omit<UnsetDueDateTimePickerProps, 'dueDate' | 'setDueDate'>> = ({
    setHasDueDateTime,
    unsetTimeMessage,
}) => (
    <div className="DueDateTimePicker unset">
        <StyledButton className="enable-time secondary" tabIndex={0} onClick={() => setHasDueDateTime(true)}>
            <Icon name="clock" />
            <span className="time-text">{unsetTimeMessage || 'Add due time…'}</span>
        </StyledButton>
    </div>
);

const DueDateTimePicker: React.FC<DueDateTimePickerProps> = ({
    hasDueDateTime,
    dueDate,
    setDueDate,
    setHasDueDateTime,
    unsetTimeMessage,
}) => {
    if (!hasDueDateTime) {
        return <UnsetDueDateTimePicker setHasDueDateTime={setHasDueDateTime} unsetTimeMessage={unsetTimeMessage} />;
    }

    return (
        <div className="DueDateTimePicker set">
            <Icon name="clock" />
            <div className="inputs">
                <TimeInput value={dueDate} onChange={setDueDate} />
                <AnchorButton className="secondary" tabIndex={0} onClick={() => setHasDueDateTime(false)}>
                    Clear
                </AnchorButton>
            </div>
        </div>
    );
};

DueDateTimePicker.propTypes = {
    hasDueDateTime: PropTypes.bool.isRequired,
    setHasDueDateTime: PropTypes.func.isRequired,
    dueDate: PropTypes.instanceOf(Date).isRequired,
    setDueDate: PropTypes.func.isRequired,
    unsetTimeMessage: PropTypes.string,
};

export default DueDateTimePicker;
